module.exports = __webpack_public_path__ + "static/img/2-1.354a14d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature/face/2-1.png
// module id = oaT7
// module chunks = 1